import { StarIcon as PhosphorStarIcon } from "@phosphor-icons/react";

export function StarIcon() {
  return (
    <PhosphorStarIcon
      aria-hidden="true"
      size={16}
      color="white"
      weight="fill"
    />
  );
}
